import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { EditOrganizationDialogComponent } from './edit-organization-dialog.component';
import { NgxCurrencyWrapperModule } from '../../shared/ngx-currency-wrapper.module';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        FormsModule,
        NgxCurrencyWrapperModule
    ],
    exports: [EditOrganizationDialogComponent],
    declarations: [EditOrganizationDialogComponent]
})
export class EditOrganizationDialogModule { }
